module.exports = __webpack_public_path__ + "img/tjfoot2.0620d04b.jpg";